import { API_URL } from "../config/connect";
import { apiFetch } from "../utils/apiErrorHandler";

export const signup = async (name, phoneNumber, user_type, bin, email = null) => {
    try {
        const requestBody = { 
            name, 
            phone_number: phoneNumber, 
            user_type: user_type, 
            company_bin: bin || null 
        };
        
        // Add email only if provided
        if (email) {
            requestBody.email = email;
        }
        
        // apiFetch automatically:
        // - Adds Accept-Language header with current user's language
        // - Extracts error messages from backend response format
        // - Throws errors with proper message from backend
        const data = await apiFetch(`${API_URL}/api/v1/auth/signup`, {
            method: 'POST',
            body: JSON.stringify(requestBody),
        });

        // Согласно документации, успешный ответ: { links: [...] }
        return data;
    } catch (error) {
        // Error message is already extracted from backend response
        // Backend sends localized messages based on Accept-Language header
        throw error;
    }
};